import { createTheme } from '@mui/material/styles';

// assets
import colors from 'assets/scss/_themes-vars.module.scss';

// project imports
import componentStyleOverrides from './compStyleOverride';
import themePalette from './palette';
import themeTypography from './typography';

/**
 * Represent theme style and structure as per Material-UI
 * @param {JsonObject} customization customization parameter object
 */

export const theme = (customization) => {
  const isDark = customization?.navType === 'dark';

  // In dark mode, remap the neutral (primary) and accent (secondary) ramps
  // onto the slate/teal dark tokens so every consumer of `colors.*` stays
  // coherent without touching each component individually.
  const color = isDark
    ? {
        ...colors,
        primaryLight: colors.darkPrimaryLight,
        primary200: colors.darkPrimary200,
        primaryMain: colors.darkPrimaryMain,
        primaryDark: colors.darkPrimaryDark,
        primary800: colors.darkPrimary800,
        secondaryLight: colors.darkSecondaryLight,
        secondary200: colors.darkSecondary200,
        secondaryMain: colors.darkSecondaryMain,
        secondaryDark: colors.darkSecondaryDark,
        secondary800: colors.darkSecondary800,
        grey50: colors.darkLevel1,
        grey100: colors.darkLevel2,
        grey400: colors.darkLevel2,
        grey700: colors.darkTextPrimary
      }
    : colors;

  const themeOption = isDark
    ? {
        colors: color,
        heading: colors.darkTextTitle,
        paper: colors.darkPaper,
        backgroundDefault: colors.darkPaper,
        background: colors.darkBackground,
        darkTextPrimary: colors.darkTextPrimary,
        darkTextSecondary: colors.darkTextSecondary,
        textDark: colors.darkTextTitle,
        menuSelected: colors.darkSecondaryMain,
        menuSelectedBack: colors.darkLevel1,
        divider: colors.darkLevel2,
        customization
      }
    : {
        colors: color,
        heading: color.grey900,
        paper: color.paper,
        backgroundDefault: color.paper,
        background: color.primaryLight,
        darkTextPrimary: color.grey700,
        darkTextSecondary: color.grey500,
        textDark: color.grey900,
        menuSelected: color.secondaryDark,
        menuSelectedBack: color.secondaryLight,
        divider: color.grey200,
        customization
      };

  const themeOptions = {
    direction: 'ltr',
    palette: themePalette(themeOption),
    mixins: {
      toolbar: {
        // minHeight: '48px',
        padding: '16px',
        '@media (min-width: 600px)': {
          // minHeight: '48px'
        }
      }
    },
    typography: themeTypography(themeOption)
  };

  const themes = createTheme(themeOptions);
  themes.components = componentStyleOverrides(themeOption);

  return themes;
};

export default theme;
